const updateURL = ({ variantID }) => {
  const url = new URL(window.location.href);
  url.searchParams.set('variant', variantID);
  url.searchParams.delete('selling_plan');

  window.history.replaceState({}, '', url);
};

export default updateURL;
